import styles from '../styles/Archives.module.css';

const NormalTitle = ({text}) => {
    return <h1 className={styles.normalTitle}>{text}</h1>
};

export default NormalTitle;